import React from 'react'
import './Copied.css'


const Copied = () => {
    return (
        <div id="holdon-overlay">
            <div id="holdon-content-container">
                <div id="holdon-message">Copied!</div>
            </div>
        </div>
    )
}

export default Copied
